import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { getOrgTermsContent } from '../../../content/utils.js';
import FieldGroup from '../../FieldGroup.jsx';
import { FormError } from '../../FormError.jsx';
import MultistepFormsFooter from '../../MultistepFormsFooter.jsx';
import MultistepFormsNav from '../../headers/FormHeaders/MultistepFormsNav.jsx';
import QuestionBlueIcon from '../../icons/QuestionBlueIcon.jsx';
import CustomTooltip from '../../CustomTooltip.jsx';

const StepLinkedFilesFrom = (props) => {
  const {
    entities,
    submitError,
    submitFailed,
    loading,
    handleSubmit,
    onCreateLinkedFile,
    onDeleteLinkedFile,
    onFieldChange,
    values,
    onCancel,
    onBack,
  } = props;

  const TooltipComponent = () => (
    <CustomTooltip
      placement="right"
      tooltip={
        <div style={{ maxWidth: '256px' }}>
          <strong>
            <h5
              style={{
                fontSize: '14px',
                fontWeight: '600',
                lineHeight: '20px',
                color: '#153142',
              }}
              className="m-b-8"
            >
              Add Linked File
            </h5>
          </strong>
          <p
            style={{
              fontSize: '12px',
              fontWeight: '400',
              lineHeight: '20px',
              color: '#7F8FA4',
            }}
            className="m-b-0 text-muted"
          >
            Simply copy the URL where you have stored your documents. Once
            added, people can easily find, download, and use the supporting
            materials and documents you've created for them - all in one easy
            place!
          </p>
        </div>
      }
      id="tooltip"
    >
      <Button
        aria-label="View Support for Change modal"
        type="button"
        className="flex flex-align-center m-l-8 btn-last-update-icon"
      >
        <QuestionBlueIcon />
      </Button>
    </CustomTooltip>
  );

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col xs={12}>
          <MultistepFormsNav
            activeIndex={3}
            onBack={onBack}
            onSubmit={handleSubmit}
            type="portfolio"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={8}>
          <p className="communication-help text-muted m-b-24">
            {getOrgTermsContent('portfolioLinkedFilesFormDescription')}
          </p>
        </Col>
      </Row>

      <Row className="m-b-60">
        <Col xs={12}>
          {entities.map(({ id, tempId }, index) => (
            <div
              key={`add-linked-file-form-${id || tempId}`}
              className="m-b-24"
            >
              <Row>
                <Col xs={6}>
                  <div className="linked-file-form">
                    <Field
                      id={`name${index}`}
                      name={`name${index}`}
                      label={`${index + 1} Linked File Title`}
                      placeholder="Linked file title"
                      type="text"
                      component={FieldGroup}
                    >
                      {(props) => (
                        <FieldGroup
                          {...props}
                          value={entities[index].name || ''}
                          onChange={(e) =>
                            onFieldChange(index, 'name', e.target.value)
                          }
                        />
                      )}
                    </Field>
                    <button
                      type="button"
                      className="btn-delete btn btn-default m-t-28"
                      onClick={() =>
                        onDeleteLinkedFile(id ? 'id' : 'tempId', id || tempId)
                      }
                    ></button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <Field
                    id={`url${index}`}
                    name={`url${index}`}
                    className="m-0"
                    placeholder="https://"
                    type="text"
                    label="URL"
                    tooltipComponent={<TooltipComponent />}
                    component={FieldGroup}
                  >
                    {(props) => (
                      <FieldGroup
                        {...props}
                        value={entities[index].url || ''}
                        onChange={(e) =>
                          onFieldChange(index, 'url', e.target.value)
                        }
                      />
                    )}
                  </Field>
                </Col>
              </Row>
            </div>
          ))}
        </Col>
        <Col xs={12}>
          <button
            disabled={entities.length && entities.some((item) => !item.name)}
            type="button"
            className="btn-link"
            onClick={onCreateLinkedFile}
          >
            {' '}
            + Add a Linked file
          </button>
        </Col>
      </Row>
      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
      </Row>
      <Row>
        <Col xs={12}>
          <MultistepFormsFooter
            values={values}
            loading={loading}
            handleSubmit={handleSubmit}
            onBack={onBack}
            onCancel={onCancel}
            finalStep
          />
        </Col>
      </Row>
    </form>
  );
};

export default StepLinkedFilesFrom;
